import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../../utils/axios";

export interface OcrScanResponse {
    message: string;
    extractedData: {
        supplierName: string;
        supplierLegalName: string;
        supplierGST: string;
        supplierPAN: string;
        supplierAddress: string;
        supplierCity: string;
        supplierPhone: string;
        supplierEmail: string;
        supplierState: string;
        supplierStateCode: string;
        billToName: string;
        billToAddress: string;
        billToGST: string;
        billToState: string;
        billToStateCode: string;
        shipToName: string;
        shipToAddress: string;
        invoiceNumber: string;
        invoiceDate: string;
        dueDate: string;
        poNumber: string;
        placeOfSupply: string;
        totalAmount: number;
        taxableAmount: number;
        cgstAmount: number;
        sgstAmount: number;
        igstAmount: number;
        isTaxTypeIgst: boolean;
        lineItems: OcrLineItem[];
        additionalCharges: { title: string; value: number }[];
        notes: string;
        bankDetails: {
            bankName: string;
            accountNumber: string;
            ifsc: string;
        };
    };
    matchedSupplier: any;
    supplierSuggestions: any[];
    matchedItems: OcrMatchedItem[];
    isSupplierFound: boolean;
    isNewSupplier: boolean;
}

export interface OcrLineItem {
    name: string;
    description: string;
    hsnCode: string;
    qty: number;
    rate: number;
    discount: number;
    discountPercentage: number;
    taxableValue: number;
    taxPercent: number;
    cgst: number;
    sgst: number;
    igst: number;
    total: number;
}

export interface OcrMatchedItem extends OcrLineItem {
    matchedSku: {
        _id: string;
        name: string;
        hsnCode: string;
        itemCode: string;
        purchasePrice: number;
        gst: string;
    } | null;
    skuSuggestions: any[];
}

// OCR Scan Invoice async thunk
export const ocrScanInvoice = createAsyncThunk(
    'invoice/ocrScanInvoice',
    async ({ file, accountId }: { file: File; accountId: string }): Promise<OcrScanResponse> => {
        const formData = new FormData();
        formData.append('invoiceImage', file);
        formData.append('accountId', accountId);

        const response = await axios.post(`/api/v1/invoice/ocr-scan`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });

        return response.data;
    }
);

// Process Purchase Invoice - single API that creates everything
export const processPurchaseInvoice = createAsyncThunk(
    'invoice/processPurchaseInvoice',
    async (payload: any) => {
        const response = await axios.post(`/api/v1/invoice/process-purchase-invoice`, payload);
        return response.data;
    }
);

